// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"d726caff","453":"43a19f67","732":"0841d349","977":"72eee48e"}[chunkId] + ".chunk.js";
};